import { UserProfile } from '@shared/types/user';

/**
 * Enum for onboarding steps
 */
export enum OnboardingStep {
  ORGANIZATION_TYPE = 1,
  ORGANIZATION_INFO = 2,
  PROFILE_INFO = 3,
  COMPLETE = 4,
}

/**
 * Organization type options
 */
export enum OrganizationType {
  CORPORATE = 'corporate',
  ORGANIZATION = 'organization',
}

/**
 * Organization information interface
 */
export interface OrganizationInfo {
  name: string;
  city: string;
  postalCode: string;
  streetAddress: string;
  country: string;
  state?: string;
  website?: string;
  size?: string;
  industry?: string;
}

/**
 * Onboarding state interface
 */
export interface OnboardingState {
  currentStep: OnboardingStep;
  organizationType: OrganizationType | null;
  organizationInfo: OrganizationInfo | null;
  profileInfo: Partial<UserProfile> | null;
  completed: boolean;
  receiveNotifications: boolean;
  isInvitedUser: boolean;
  invitationId?: string;
  organizationId?: string;
}

/**
 * Onboarding progress interface for API
 */
export interface OnboardingProgress {
  currentStep: number;
  organizationType?: OrganizationType;
  organizationInfo?: OrganizationInfo;
  profileInfo?: Partial<UserProfile>;
  completed: boolean;
  receiveNotifications?: boolean;
  isInvitedUser?: boolean;
  invitationId?: string;
  organizationId?: string;
}
